"use strict";
// Core modules — loaded via dynamic import to break the 425ms+ long task
// into smaller chunks. Custom elements auto-upgrade when registered later.
import "./cart-components.js";
import("theme:global-components");
import("theme:cart-drawer");
// All other modules are now loaded via data-module auto-loader in global.js:
// theme:popup-components, theme:quick-view, theme:wishlist-button,
// theme:compare-button, theme:countdown-timer, theme:variant-radios,
// theme:bundle-components, theme:product-form, theme:lookbook-components,
// theme:section-components

/* Safe Motion wrapper — returns no-op fallback if Motion is not yet loaded */
function safeMotionAnimate(target, keyframes, options) {
  if (typeof Motion !== "undefined" && Motion.animate) {
    return Motion.animate(target, keyframes, options);
  }
  // Fallback: apply final CSS values immediately
  var els = [];
  if (typeof target === "number") {
    if (options && options.onUpdate) options.onUpdate(keyframes);
    var p = Promise.resolve();
    p.cancel = function(){};
    p.finished = Promise.resolve();
    if (options && options.onComplete) setTimeout(options.onComplete, 0);
    return p;
  }
  if (target instanceof Element) els = [target];
  else if (target instanceof NodeList || target instanceof HTMLCollection) els = Array.from(target);
  else if (Array.isArray(target)) els = target;
  if (els.length) {
    els.forEach(function(el) {
      if (!el || !el.style) return;
      var tf = [];
      for (var k in keyframes) {
        var v = keyframes[k];
        if (Array.isArray(v)) v = v[v.length - 1];
        if (k === "y") tf.push("translateY(" + (typeof v === "number" ? v + "px" : v) + ")");
        else if (k === "x") tf.push("translateX(" + (typeof v === "number" ? v + "px" : v) + ")");
        else if (k === "scale") tf.push("scale(" + v + ")");
        else if (k === "transform") el.style.transform = v;
        else el.style[k] = v;
      }
      if (tf.length) el.style.transform = tf.join(" ");
    });
  }
  var rp = Promise.resolve();
  rp.cancel = function(){};
  rp.finished = Promise.resolve();
  if (options && options.onComplete) setTimeout(options.onComplete, 0);
  return rp;
}
var activeComparison = null;

function slideActiveComparison(e) {
  if (!activeComparison) return false;
  var pos;
  var w = activeComparison.currentWidth();
  if (activeComparison.clicked === 0 || w === 0) return false;
  pos = activeComparison.getCursorPos(e);
  if (pos < 0) pos = 0;
  if (pos > w) pos = w;
  activeComparison.slide(pos);
}

function finishActiveComparison() {
  if (!activeComparison) return;
  activeComparison.clicked = 0;
  activeComparison = null;
}

window.addEventListener("mouseup", finishActiveComparison);
window.addEventListener("touchend", finishActiveComparison);
window.addEventListener("mousemove", slideActiveComparison);
window.addEventListener("touchmove", slideActiveComparison, { passive: true });

function initComparisons(root) {
  var x, i;
  root = root || document;
  x = root.getElementsByClassName("img-comp-overlay");
  for (i = 0; i < x.length; i++) {
    compareImages(x[i]);
  }
  function compareImages(img) {
    var slider,
      clicked = 0;
    const icc = img.closest(".img-comp-container");
    if (!icc) return;
    slider = icc.querySelector(".image-comparison__button");
    if (!slider || slider.dataset.jmComparisonBound === "1") return;
    slider.dataset.jmComparisonBound = "1";
    slider.addEventListener("touchstart", slideReady, { passive: false });
    slider.addEventListener("mousedown", slideReady);

    function currentWidth() {
      return img.offsetWidth || 0;
    }

    function slideReady(e) {
      e.preventDefault();
      clicked = 1;
      activeComparison = comparisonState;
    }
    function getCursorPos(e) {
      e = e.changedTouches ? e.changedTouches[0] : e;
      const a = img.getBoundingClientRect();
      let x = e.clientX - a.left + 14;
      x = Math.max(0, Math.min(x, currentWidth()));

      return x;
    }

    function slide(x) {
      var w = currentWidth();
      if (w === 0) return;
      if (slider) {
        const sliderHalfWidth = slider.offsetWidth / 2;
        let percent = ((x - sliderHalfWidth) / w) * 100;
        let min = (sliderHalfWidth / icc.getBoundingClientRect().width) * 100;
        percent = Math.max(min - 0.1, Math.min(percent, 100));
        img
          .closest(".img-comp-container")
          .setAttribute("style", "--percent: " + percent + "%;");
      }
    }
    var comparisonState = {
      clicked: clicked,
      currentWidth: currentWidth,
      getCursorPos: getCursorPos,
      slide: slide
    };
    Object.defineProperty(comparisonState, "clicked", {
      get: function () {
        return clicked;
      },
      set: function (value) {
        clicked = value;
      }
    });
  }
}

initComparisons(document);
document.addEventListener("shopify:section:load", function (event) {
  initComparisons(event.target);
});
document.addEventListener("theme:dom-updated", function (event) {
  initComparisons((event.detail && event.detail.container) || document);
});
let resizeTimeout;
window.addEventListener("resize", () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(() => {
    initComparisons(document);
  }, 200);
});

function eventFlashingBrowseTab() {
  var enable = window.flashingBrowseTab?.enable,
    myTimer,
    message,
    titleTag = document.getElementsByTagName("title")[0],
    first_notification = window.flashingBrowseTab?.firstNotification,
    secondary_notification = window.flashingBrowseTab?.secondaryNotification;
  if (enable && titleTag) {
    var originalTitle = titleTag.innerText;
    var isActive = true;
    document.addEventListener("visibilitychange", () => {
      document.visibilityState === "visible"
        ? (function () {
          if (isActive) return;
          clearInterval(myTimer), (titleTag.innerText = originalTitle);
        })()
        : (function () {
          var i = 1;
          if (
            ((isActive = false),
              !first_notification || !secondary_notification)
          )
            return;
          myTimer = setInterval(function () {
            if (i == 1) {
              message = first_notification;
              i = 2;
            } else {
              message = secondary_notification;
              i = 1;
            }
            titleTag.innerText = message;
          }, 2000);
        })();
    });
  }
}
eventFlashingBrowseTab();

function initializeLazyLoad() {
  const videoPlaceholders = document.querySelectorAll(".lazy-video-link");
  const loadYouTubeVideo = (element) => {
    const videoId = element.getAttribute("data-video-id");
    const iframe = document.createElement("iframe");
    iframe.src = `https://www.youtube.com/embed/${videoId}?controls=0&autoplay=1&mute=1&playsinline=1&loop=1&playlist=${videoId}`;
    iframe.allowFullscreen = true;
    iframe.frameBorder = "0";
    iframe.allow =
      "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture";
    element.innerHTML = "";
    element.appendChild(iframe);
  };
  const loadVimeoVideo = (element) => {
    const videoId = element.getAttribute("data-video-id");
    const iframe = document.createElement("iframe");
    iframe.src = `https://player.vimeo.com/video/${videoId}?controls=0background=1&autoplay=1&muted=1&loop=1`;
    iframe.allowFullscreen = true;
    iframe.allow = "autoplay; fullscreen; picture-in-picture";
    iframe.frameBorder = "0";
    element.innerHTML = "";
    element.appendChild(iframe);
  };
  const loadVideo = (element) => {
    const videoType = element.getAttribute("data-video-type");
    if (videoType === "youtube") {
      loadYouTubeVideo(element);
    } else if (videoType === "vimeo") {
      loadVimeoVideo(element);
    }
  };
  const lazyLoadVideos = () => {
    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          loadVideo(entry.target);
          observer.unobserve(entry.target);
        }
      });
    });
    videoPlaceholders.forEach((videoPlaceholder) => {
      observer.observe(videoPlaceholder);
    });
  };
  lazyLoadVideos();
}
initializeLazyLoad();
document.addEventListener("shopify:section:load", initializeLazyLoad);

const slideAnime = (() => {
  let isAnimating = false;

  return (setOptions) => {
    const defaultOptions = {
      target: false,
      animeType: "slideToggle",
      duration: 250,
      easing: "ease",
      isDisplayStyle: "block",
      parent: false,
      addFunction: () => { },
    };
    const options = Object.assign({}, defaultOptions, setOptions);
    const target = options.target;
    const ownAnimate = options.ownAnimate;
    if (ownAnimate) {
      isAnimating = false;
    }
    const parent = options.parent;
    if (!target) {
      return;
    }

    if (isAnimating) {
      return;
    }
    isAnimating = true;
    parent.classList?.toggle("opened");

    let animeType = options.animeType;
    const styles = getComputedStyle(target);
    if (animeType === "slideToggle") {
      animeType = styles.display === "none" ? "slideDown" : "slideUp";
    }
    if (
      (animeType === "slideUp" && styles.display === "none") ||
      (animeType === "slideDown" && styles.display !== "none") ||
      (animeType !== "slideUp" && animeType !== "slideDown")
    ) {
      isAnimating = false;
      return false;
    }
    target.style.overflow = "hidden";
    const duration = options.duration;
    const easing = options.easing;
    const isDisplayStyle = options.isDisplayStyle;

    if (animeType === "slideDown") {
      target.style.display = isDisplayStyle;
    }
    const heightVal = {
      height: target.getBoundingClientRect().height + "px",
      marginTop: styles.marginTop,
      marginBottom: styles.marginBottom,
      paddingTop: styles.paddingTop,
      paddingBottom: styles.paddingBottom,
    };

    Object.keys(heightVal).forEach((key) => {
      if (parseFloat(heightVal[key]) === 0) {
        delete heightVal[key];
      }
    });
    if (Object.keys(heightVal).length === 0) {
      isAnimating = false;
      return false;
    }
    let slideAnime;
    if (animeType === "slideDown") {
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = 0;
      });
      slideAnime = target.animate(heightVal, {
        duration: duration,
        easing: easing,
      });
    } else if (animeType === "slideUp") {
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = heightVal[key];
        heightVal[key] = 0;
      });
      slideAnime = target.animate(heightVal, {
        duration: duration,
        easing: easing,
      });
    }
    slideAnime.finished.then(() => {
      options.addFunction();
      target.style.overflow = "";
      Object.keys(heightVal).forEach((key) => {
        target.style[key] = "";
      });
      if (animeType === "slideUp") {
        target.style.display = "none";
      }
      isAnimating = false;
    });
  };
})();

class CollectionOverviews extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initSections();

    document.addEventListener("shopify:section:load", (event) => {
      if (this.contains(event.target)) {
        this.initSection(event.target);
      }
    });

    document.addEventListener("shopify:section:reorder", (event) => {
      if (this.contains(event.target)) {
        this.initSection(event.target);
      }
    });
  }

  initSections() {
    const sections = this.querySelectorAll(".section__block-inner");
    sections.forEach((section) => {
      this.initSection(section);
    });
  }

  initSection(section) {
    const blocks = section.querySelectorAll(".content-overview-block");
    const banners = section.querySelectorAll(".banner__media-collection");
    banners.forEach((banner) => {
      banner.classList.remove("active");
      safeMotionAnimate(banner,
        {
          opacity: 0,
          scale: 0.95
        },
        {
          duration: 0.2,
          easing: "ease-out"
        }
      );
    });

    blocks.forEach((block) => {
      block.classList.remove("active");
    });

    if (banners.length > 0) {
      banners[0].classList.add("active");
      safeMotionAnimate(banners[0],
        {
          opacity: [0, 1],
          scale: [0.95, 1]
        },
        {
          duration: 0.4,
          easing: "ease-out"
        }
      );
    }

    if (blocks.length > 0) {
      blocks[0].classList.add("active");
    }

    blocks.forEach((block) => {
      block.addEventListener("mouseenter", () => {
        if (block.classList.contains("active")) {
          return;
        }
        const blockIndex = block.getAttribute("data-index");

        const currentActiveBanners = section.querySelectorAll(".banner__media-collection.active");
        const fadeOutPromises = Array.from(currentActiveBanners).map(banner => {
          banner.classList.remove("active");
          return safeMotionAnimate(banner,
            {
              opacity: 0,
              scale: 0.95
            },
            {
              duration: 0.2,
              easing: "ease-in"
            }
          );
        });

        blocks.forEach((b) => {
          b.classList.remove("active");
        });

        const targetBanner = section.querySelector(
          `.banner__media-collection[data-index="${blockIndex}"]`
        );

        Promise.all(fadeOutPromises).then(() => {
          if (targetBanner) {
            targetBanner.classList.add("active");
            safeMotionAnimate(targetBanner,
              {
                opacity: [0, 1],
                scale: [0.95, 1]
              },
              {
                duration: 0.3,
                easing: "ease-out"
              }
            );
          }
        });

        block.classList.add("active");
      });
    });
  }
}

customElements.define("collection-overviews", CollectionOverviews);

class MultiContent extends SlideSection {
  constructor() {
    super();
    this.enable = this.dataset.enable;
    this.id = this.dataset.id;
    this.swiperSlideInnerHtml = this.innerHTML;
    this.init();
  }
  init() {
    if (this.enable == "true") {
      let width = window.innerWidth;
      window.addEventListener("resize", () => {
        const newWidth = window.innerWidth;
        if (newWidth <= 767 && width > 767) {
          this.actionOnMobile();
        }
        if (newWidth > 767 && width <= 767) {
          this.actionOutMobile();
        }
        width = newWidth;
      });
      if (width <= 576) {
        this.actionOnMobile();
      } else {
        this.actionOutMobile();
      }
    }
  }
  actionOnMobile() {
    this.classList.add("swiper");
    const html = this.swiperSlideInnerHtml.replaceAll(
      "section__block",
      "swiper-slide"
    );
    const wrapper = `<div class='swiper-wrapper'>${html}</div> <div
    class="swiper-pagination swiper-pagination-${this.id}  ${this.enable && this.dataset.mobile != 1.5 ? "flex" : "hidden"
      } px-15 lh-1 bottom-30 justify-content-center"
    style="--swiper-pagination-bottom: 3rem;--swiper-pagination-position: static;"
  ></div> `;
    this.innerHTML = wrapper;
    this.initSlide();
  }
  actionOutMobile() {
    if (this.classList.contains("swiper")) {
      this.classList.remove("swiper");
      this.innerHTML = this.swiperSlideInnerHtml;
    }
  }
}
customElements.define("multi-content", MultiContent);
var wishlistHeader = (function () {
  const readIds = (storageKey) => {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  return {
    init: function () {
      this.handleCount();
    },
    handleCount: function () {
      const wishlist = document.querySelectorAll(".wishlist-count");
      const items = readIds("mm__wishlist-items");
      const hasItems = items.length > 0;
      wishlist.forEach((item) => {
        item.innerText = hasItems ? items.length : 0;
      });
      // Toggle red heart on header and mobile wishlist icons
      document.querySelectorAll(".header__wishlist, .wishlist-icon-bubble").forEach((el) => {
        el.classList.toggle("has-items", hasItems);
      });
    },
  };
})();
wishlistHeader.init();

var compareHeader = (function () {
  const readIds = (storageKey) => {
    const raw = localStorage.getItem(storageKey);
    if (!raw) return [];
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  };

  return {
    init: function () {
      this.handleCount();
    },
    handleCount: function () {
      const compare = document.querySelectorAll(".compare-count");
      const items = readIds("mm__compare-items");
      const hasItems = items.length > 0;
      compare.forEach((item) => {
        item.innerText = hasItems ? items.length : 0;
      });
      document.querySelectorAll(".header__compare, .compare-icon-bubble").forEach((el) => {
        el.classList.toggle("has-items", hasItems);
        el.classList.toggle("hidden", !hasItems);
      });
    },
  };
})();
compareHeader.init();

window.themeHeaderCounters = {
  refreshWishlist: () => wishlistHeader.init(),
  refreshCompare: () => compareHeader.init(),
  refreshAll: () => {
    wishlistHeader.init();
    compareHeader.init();
  },
};

document.addEventListener("theme:wishlist-updated", () => {
  window.themeHeaderCounters.refreshWishlist();
});
document.addEventListener("theme:compare-updated", () => {
  window.themeHeaderCounters.refreshCompare();
});
window.addEventListener("storage", (event) => {
  if (event.key === "mm__wishlist-items") {
    window.themeHeaderCounters.refreshWishlist();
  }
  if (event.key === "mm__compare-items") {
    window.themeHeaderCounters.refreshCompare();
  }
});

// Cart icon highlight: toggle .has-items on #cart-icon-bubble(s) when cart has items
function updateCartIconHighlight(itemCount) {
  ["cart-icon-bubble", "cart-icon-bubble-mobile"].forEach(function (id) {
    var el = document.getElementById(id);
    if (el) el.classList.toggle("has-items", itemCount > 0);
  });
}
window.updateCartIconHighlight = updateCartIconHighlight;
// Fetches /cart.json on every page load to correct the server-rendered count
// when the HTML is served from a CDN edge cache (Cloudflare).
// Uses a cache-busting query param so Cloudflare never returns a stale response.
(function () {
  var countEl = document.querySelector(".cart-count:not(.cart-count-drawer)");
  if (countEl) {
    var count = parseInt(countEl.textContent.trim(), 10);
    if (!isNaN(count)) updateCartIconHighlight(count);
  }
  fetch("/cart/update.js", { method: "POST", credentials: "same-origin", cache: "no-store", headers: { "Content-Type": "application/json", "X-Requested-With": "XMLHttpRequest" }, body: JSON.stringify({ sections: [] }) })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var n = cart.item_count || 0;
      // Update all cart-count badges (header, mobile nav, drawer)
      document.querySelectorAll(".cart-count").forEach(function (el) {
        if (el.classList.contains("cart-count-drawer")) {
          el.textContent = n;
        } else {
          var vis = el.querySelector(".visually-hidden");
          // Clear existing text nodes
          el.childNodes.forEach(function (c) {
            if (c !== vis && c.nodeType === Node.TEXT_NODE) c.textContent = "";
          });
          // If there's no visually-hidden span (mobile nav empty-cart case)
          var ariaSpan = el.querySelector("[aria-hidden]");
          if (ariaSpan) {
            ariaSpan.textContent = n < 100 ? String(n) : "~";
          } else if (vis) {
            el.insertBefore(document.createTextNode(n < 100 ? String(n) : "~"), vis);
          } else {
            el.textContent = n < 100 ? String(n) : "~";
          }
        }
      });
      // Update subtotal price display (mega-menu cart)
      document.querySelectorAll("[data-cart-subtotal-price]").forEach(function (el) {
        if (typeof Shopify !== "undefined" && Shopify.formatMoney) {
          el.textContent = Shopify.formatMoney(cart.total_price);
        }
      });
      updateCartIconHighlight(n);
    })
    .catch(function () { /* network error — keep server-rendered count */ });
})();

function HoverIntent(exitTime, elements, userConfig) {
  if (!userConfig || !userConfig.onEnter || !userConfig.onExit) {
    throw "onEnter and onExit callbacks must be provided";
  }
  const config = {
    exitDelay: exitTime,
    interval: 80,
    sensitivity: 6,
    ...userConfig,
  };
  const allElems = elements;

  for (const elem of allElems) {
    if (!elem) continue;
    // Per-element state avoids cross-element timer collisions
    let pollTimer = null;
    let exitTimer = null;
    let prevX, prevY, currX, currY;
    elem.isActive = false;

    const mouseCompare = function () {
      const dx = prevX - currX, dy = prevY - currY;
      if (dx * dx + dy * dy < config.sensitivity * config.sensitivity) {
        activate();
      } else {
        prevX = currX;
        prevY = currY;
        pollTimer = setTimeout(mouseCompare, config.interval);
      }
    };

    const activate = function () {
      clearTimeout(exitTimer);
      exitTimer = null;
      // Close any other active sibling
      for (const other of allElems) {
        if (!other || other === elem) continue;
        if (other.isActive) {
          other._hoverDeactivate?.();
        }
      }
      if (!elem.isActive) {
        elem.isActive = true;
        config.onEnter(elem);
      }
    };

    elem._hoverDeactivate = function () {
      clearTimeout(pollTimer);
      clearTimeout(exitTimer);
      pollTimer = null;
      exitTimer = null;
      if (elem.isActive) {
        elem.isActive = false;
        config.onExit(elem);
      }
    };

    elem.addEventListener("mousemove", function (ev) {
      currX = ev.pageX;
      currY = ev.pageY;
    });

    elem.addEventListener("mouseenter", function (ev) {
      clearTimeout(exitTimer);
      exitTimer = null;
      prevX = currX = ev.pageX;
      prevY = currY = ev.pageY;
      if (elem.isActive) return;
      clearTimeout(pollTimer);
      pollTimer = setTimeout(mouseCompare, config.interval);
    });

    elem.addEventListener("mouseleave", function () {
      clearTimeout(pollTimer);
      pollTimer = null;
      if (!elem.isActive) return;
      exitTimer = setTimeout(function () {
        elem.isActive = false;
        config.onExit(elem);
      }, config.exitDelay);
    });
  }
}

let BlsMainMenuShopify = (function () {
  return {
    init: function () {
      this.initMenu();
      this.initMainMenu();
      this.initMobileMenu();
      this.initVerticalMenu();
    },

    initMenu: function () {
      const header = document.querySelector("header");
      if (!header) return;

      // Cache DOM elements
      const elements = {
        categoriesListMenuMobile: document.querySelector(
          ".categories-list-menu-mobile"
        ),
        categoriesListMenu: document.querySelector(
          '[data-menu="categories-list"]'
        ),
        categoriesListMenuVertical: document.querySelector(
          '[data-menu="verticalmenu-list"]'
        ),
        categoriesListMenuVerticalMobile: document.querySelector(
          ".verticalmenu-mobile"
        ),
        horizontalList: document.querySelector("nav.mobile .horizontal-list"),
      };

      // Calculate section padding bottom value
      const sectionPbValue = this.calculateSectionPadding(header);

      // Initialize fade-in-down animation if present
      this.initFadeInDownAnimation(header, sectionPbValue);

      // Handle menu tab switching
      this.setupMenuTabSwitching(elements);

      // Initialize menu tab state based on window width
      this.updateMenuTabState(elements);
      this.updateMenuVerticalMobile(elements);

      // Add resize event listener for responsive behavior
      window.addEventListener("resize", () =>
        this.updateMenuTabState(elements)
      );
      window.addEventListener("resize", () =>
        this.updateMenuVerticalMobile(elements)
      );
    },

    calculateSectionPadding: function (header) {
      let sectionPbValue = parseInt(
        getComputedStyle(header).getPropertyValue("--section-pb").trim()
      );
      if (header.querySelector(".header__layout-2")) {
        sectionPbValue = 0;
      }
      return sectionPbValue;
    },

    _isPrimaryTouch: function () {
      return window.matchMedia('(pointer: coarse) and (hover: none)').matches;
    },

    _useCoarsePointerMenu: function () {
      return window.matchMedia('(pointer: coarse)').matches;
    },

    hydrateSubmenu: function (menuParent) {
      if (!menuParent) return;
      const tpl = menuParent.querySelector('template[data-lazy-submenu]');
      if (tpl) {
        menuParent.appendChild(tpl.content);
        tpl.remove();
        menuParent.removeAttribute('data-has-submenu');
      }
    },

    _setLevel0SubmenuVisible: function (item, header, visible) {
      const submenu = item.querySelector('.submenu-horizontal');
      if (visible) {
        item.classList.add('visible');
        if (submenu && header) {
          const outerRect = header.getBoundingClientRect();
          const innerRect = item.getBoundingClientRect();
          const offset = outerRect.bottom - innerRect.bottom;
          submenu.style.visibility = 'visible';
          submenu.style.transform = `translateY(${offset}px)`;
          const sticky = header.getAttribute('data-sticky');
          if (sticky === 'on-scroll-up') header.classList.add('open-submenu');
          if (!header.classList.contains('border-bottom')) header.classList.add('active');
        } else if (submenu) {
          submenu.style.visibility = 'visible';
          submenu.style.transform = 'none';
        }
      } else {
        item.classList.remove('visible');
        item.querySelectorAll('.level-1.is-expanded').forEach((l1) => l1.classList.remove('is-expanded'));
        if (submenu) {
          submenu.style.visibility = 'hidden';
          submenu.style.transform = 'translateY(-105%)';
        }
        if (header && !document.querySelector('.menu-parent__horizontal.visible')) {
          header.classList.remove('active', 'open-submenu');
        }
      }
    },

    _toggleLevel0Submenu: function (item, items, header) {
      this.hydrateSubmenu(item);
      if (!item.querySelector('.submenu')) return false;
      const wasVisible = item.classList.contains('visible');
      items.forEach((other) => {
        if (other !== item && other.classList.contains('visible')) {
          this._setLevel0SubmenuVisible(other, header, false);
        }
      });
      this._setLevel0SubmenuVisible(item, header, !wasVisible);
      return true;
    },

    _setupTouchMenuToggle: function (selector, header, sectionPbValue) {
      if (this._touchMenuInitialized) return; // prevent duplicate listeners on re-render
      this._touchMenuInitialized = true;
      const items = document.querySelectorAll(selector);
      items.forEach(item => {
        const link = item.querySelector(':scope > menu-item > a');
        if (link) {
          link.addEventListener('click', (e) => {
            if (window.innerWidth < 1025) return; // let mobile drawer handle it
            if (!this._toggleLevel0Submenu(item, items, header)) return;
            e.preventDefault();
          });
        }
      });
      // Close menu when clicking outside
      document.addEventListener('click', (e) => {
        if (window.innerWidth < 1025) return;
        items.forEach((item) => {
          if (!item.contains(e.target) && item.classList.contains('visible')) {
            this._setLevel0SubmenuVisible(item, header, false);
          }
        });
      });
    },

    // Desktop (mouse) click: never navigate when a submenu exists; open on
    // click if hover did not already show the panel (keyboard/accessibility).
    _setupDesktopMenuClickToggle: function (selector, header, sectionPbValue) {
      if (this._desktopClickToggleInitialized) return;
      this._desktopClickToggleInitialized = true;
      const items = document.querySelectorAll(selector);
      items.forEach((item) => {
        const link = item.querySelector(':scope > menu-item > a');
        if (!link) return;
        link.addEventListener('click', (e) => {
          if (window.innerWidth < 1025) return;
          this.hydrateSubmenu(item);
          if (!item.querySelector('.submenu')) return;
          e.preventDefault();
          if (!item.classList.contains('visible')) {
            items.forEach((other) => {
              if (other !== item && other.classList.contains('visible')) {
                this._setLevel0SubmenuVisible(other, header, false);
              }
            });
            this._setLevel0SubmenuVisible(item, header, true);
          }
        });
      });
    },

    initFadeInDownAnimation: function (header, sectionPbValue) {
      const menuSelector = '.menu-parent__horizontal';
      this.setupMegaMenuLevelClicks();

      if (this._useCoarsePointerMenu()) {
        this._setupTouchMenuToggle(menuSelector, header, sectionPbValue);
        return;
      }

      const fadeInDown = document.querySelector('.fade-in-down');
      if (!fadeInDown) {
        this.setupSimpleHoverIntent(180, menuSelector);
        this._setupDesktopMenuClickToggle(menuSelector, header, sectionPbValue);
        return;
      }

      HoverIntent(180, document.querySelectorAll(menuSelector), {
        onEnter: (targetItem) =>
          this.handleMenuEnter(targetItem, header, sectionPbValue),
        onExit: (targetItem) => this.handleMenuExit(targetItem, header),
      });
      this._setupDesktopMenuClickToggle(menuSelector, header, sectionPbValue);
    },

    setupSimpleHoverIntent: function (time, selector) {
      const self = this;
      HoverIntent(time, document.querySelectorAll(selector), {
        onEnter: function (targetItem) {
          self.hydrateSubmenu(targetItem);
          targetItem.classList.add('visible');
        },
        onExit: function (targetItem) {
          targetItem.classList.remove('visible');
          targetItem.querySelectorAll('.level-1.is-expanded').forEach((item) => {
            item.classList.remove('is-expanded');
          });
        },
      });
    },

    setupMegaMenuLevelClicks: function () {
      if (this._levelClicksInitialized) return;
      this._levelClicksInitialized = true;
      // Capture phase: fires before bubbling and before browser default action.
      // This ensures e.preventDefault() runs even if other handlers interfere.
      document.addEventListener('click', function (e) {
        if (window.innerWidth < 1025) return;
        // Match level-1 links that have child menus (both mega-menu and dropdown)
        var target = e.target;
        var link = target.closest ? target.closest('.level-1 > menu-item > .menu_item-link') : null;
        if (!link) return;
        // Ensure we're inside the horizontal menu
        var menuParent = link.closest('.menu-parent__horizontal');
        if (!menuParent) return;
        var levelItem = link.closest('.level-1');
        if (!levelItem) return;
        var subMenu = levelItem.querySelector('.sub-children-menu');
        if (!subMenu) return;
        e.preventDefault();
        e.stopPropagation();
        var isExpanding = !levelItem.classList.contains('is-expanded');
        if (isExpanding) {
          levelItem.parentElement.querySelectorAll('.level-1.is-expanded').forEach(function(sibling) {
            if (sibling !== levelItem) sibling.classList.remove('is-expanded');
          });
        }
        levelItem.classList.toggle('is-expanded');
      }, true); // true = capture phase
    },

    handleMenuEnter: function (targetItem, header, sectionPbValue) {
      this.hydrateSubmenu(targetItem);
      const submenu = targetItem.querySelector(".submenu-horizontal");
      if (!submenu) return;

      const width = window.innerWidth;
      if (width < 1025) return;

      const sticky = header?.getAttribute("data-sticky");
      if (sticky == "on-scroll-up") {
        header.classList.add("open-submenu");
      }

      if (document.documentElement.classList.contains("open-search")) {
        this.handleMenuEnterWithSearchOpen(targetItem, submenu, sectionPbValue);
      } else {
        this.handleStandardMenuEnter(targetItem, submenu, header);
      }
    },

    handleStandardMenuEnter: function (targetItem, submenu, header) {
      const outerRect = header.getBoundingClientRect();
      const innerRect = targetItem.getBoundingClientRect();
      const heightScrollDown = outerRect.bottom - innerRect.bottom;

      safeMotionAnimate(
        submenu,
        {
          y: ["-105%", heightScrollDown],
          visibility: ["hidden", "visible"],
        },
        {
          ease: [0.7, 0, 0.2, 1],
          duration: 0.35,
        }
      );

      targetItem.classList.add("visible");
      if (!header.classList.contains("border-bottom")) {
        header.classList.add("active");
      }
    },

    handleMenuEnterWithSearchOpen: function (
      targetItem,
      submenu,
      sectionPbValue
    ) {
      const ps = document.querySelector(".popup-search");
      const overlay_search = document.querySelector(".overlay_search");
      const sf = document.querySelector(".search-full");

      if (!ps || !overlay_search || !sf) return;

      overlay_search.classList.remove("open");
      let topCaculate = sf.getBoundingClientRect().bottom + 10;

      Promise.all([
        safeMotionAnimate(
          ps,
          {
            y: [topCaculate, "-105%"],
            visibility: ["visible", "hidden"],
          },
          {
            ease: [0.7, 0, 0.2, 1],
            duration: 0.2,
          }
        ),
        safeMotionAnimate(
          overlay_search,
          {
            opacity: [1, 0],
            visibility: ["visible", "hidden"],
          },
          {
            ease: [0.7, 0, 0.2, 1],
            duration: 0.2,
          }
        ),
      ]).then(() => {
        setTimeout(() => {
          // Update document classes
          if (document.documentElement.classList.contains("open-minicart")) {
            document.documentElement.classList.remove("open-search");
          } else {
            document.documentElement.classList.remove(
              "open-drawer",
              "open-search"
            );
            root.style.removeProperty("padding-right");
          }

          // Show submenu with animation
          safeMotionAnimate(
            submenu,
            {
              y: ["-105%", sectionPbValue],
              visibility: ["hidden", "visible"],
            },
            {
              ease: [0.7, 0, 0.2, 1],
              duration: 0.35,
            }
          );
          targetItem.classList.add("visible");
        }, 20);
      });
    },

    handleMenuExit: function (targetItem, header) {
      const submenu = targetItem.querySelector(".submenu-horizontal");
      if (!submenu) return;

      const width = window.innerWidth;
      if (width < 1025) return;

      const sticky = header?.getAttribute("data-sticky");
      const outerRect = header.getBoundingClientRect();
      const innerRect = targetItem.getBoundingClientRect();
      const heightScrollDown = outerRect.bottom - innerRect.bottom;

      if (sticky == "on-scroll-up") {
        header.classList.remove("open-submenu");
      }

      safeMotionAnimate(
        submenu,
        {
          y: [heightScrollDown, "-105%"],
          visibility: ["visible", "hidden"],
        },
        {
          ease: [0.7, 0, 0.2, 1],
          duration: 0.4,
        }
      );

      targetItem.classList.remove("visible");
      // Reset Level 1 expand states when mega menu closes
      targetItem.querySelectorAll('.level-1.is-expanded').forEach(item => {
        item.classList.remove('is-expanded');
      });
      if (header.classList.contains("active")) {
        header.classList.remove("active");
      }
    },

    setupMenuTabSwitching: function (elements) {
      document.querySelectorAll(".menu-mobile-title a").forEach((tabToggle) => {
        tabToggle.addEventListener("click", (e) => {
          e.preventDefault();
          const target = e.currentTarget;
          const data = target.dataset.menu;

          // Reset active state on all tabs
          document
            .querySelectorAll(".menu-mobile-title a")
            .forEach((item) => item.classList.remove("active"));

          // Set current tab as active
          target.classList.add("active");

          // Show appropriate menu based on selected tab
          this.showMenuForTab(data, elements);
        });
      });
    },

    showMenuForTab: function (tabId, elements) {
      const { horizontalList, categoriesListMenuMobile } = elements;
      const categoriesListMenuVerticalMobile = document.querySelector(
        ".verticalmenu-mobile"
      );

      if (!horizontalList) return;

      // Hide horizontal list if we're showing a specific menu
      horizontalList.style.display =
        tabId !== "horizontal-list" ? "none" : "block";

      // Show appropriate menu based on tab
      if (tabId === "categories-list") {
        if (categoriesListMenuMobile)
          categoriesListMenuMobile.style.display = "block";
        if (categoriesListMenuVerticalMobile)
          categoriesListMenuVerticalMobile.style.display = "none";
      } else if (tabId === "verticalmenu-list") {
        if (categoriesListMenuMobile)
          categoriesListMenuMobile.style.display = "none";
        if (categoriesListMenuVerticalMobile)
          categoriesListMenuVerticalMobile.style.display = "block";
      } else {
        if (categoriesListMenuMobile)
          categoriesListMenuMobile.style.display = "none";
        if (categoriesListMenuVerticalMobile)
          categoriesListMenuVerticalMobile.style.display = "none";
      }
    },

    updateMenuVerticalMobile: function (elements) {
      const windowWidth = window.innerWidth;
      if (windowWidth <= 1024) {
        const headerVertical = document.querySelector(".header-vertical");
        const headerVerticalMobile = document.querySelector(
          ".verticalmenu-mobile"
        );
        const titleVertical = headerVerticalMobile?.dataset.title;
        const menuMobileTitle = document.querySelector(".menu-mobile-title");
        if (!headerVertical) return;
        if (!menuMobileTitle.querySelector('[data-menu="verticalmenu-list"]')) {
          const contentAppendTitleVertical = `
            <a
              class="no-underline heading-style py-10"
              data-menu="verticalmenu-list"
              role="link"
              aria-disabled="true"
            >
              ${titleVertical}
            </a>
          `;
          menuMobileTitle.insertAdjacentHTML(
            "beforeend",
            contentAppendTitleVertical
          );
          const newTabButton = menuMobileTitle.querySelector(
            '[data-menu="verticalmenu-list"]'
          );
          if (newTabButton) {
            newTabButton.addEventListener("click", (e) => {
              e.preventDefault();
              document
                .querySelectorAll(".menu-mobile-title a")
                .forEach((item) => item.classList.remove("active"));
              newTabButton.classList.add("active");
              this.showMenuForTab("verticalmenu-list", elements);
            });
          }
        }
        const wrapperVerticalmenu = document.querySelector(
          ".verticalmenu-mobile"
        );
        const navigationMenuContent = document.querySelector(
          ".navigation__menu-content-mobile"
        );
        if (!wrapperVerticalmenu || !navigationMenuContent) {
          return;
        }
        if (!navigationMenuContent.querySelector(".verticalmenu-mobile")) {
          const cloneWrapper = wrapperVerticalmenu.cloneNode(true);
          navigationMenuContent.appendChild(cloneWrapper);
        }
      }
    },

    updateMenuTabState: function (elements) {
      const windowWidth = window.innerWidth;
      const {
        horizontalList,
        categoriesListMenu,
        categoriesListMenuVertical,
        categoriesListMenuMobile,
        categoriesListMenuVerticalMobile,
      } = elements;

      if (!horizontalList || !categoriesListMenu) return;

      if (windowWidth <= 1024) {
        // Mobile view
        if (
          categoriesListMenu?.classList.contains("active") ||
          categoriesListMenuVertical?.classList.contains("active")
        ) {
          horizontalList.style.display = "none";
        }

        if (
          categoriesListMenuVerticalMobile &&
          categoriesListMenuVertical?.classList.contains("active")
        ) {
          categoriesListMenuVerticalMobile.style.display = "block";
        }
      } else {
        // Desktop view
        if (
          categoriesListMenuMobile &&
          categoriesListMenu?.classList.contains("active")
        ) {
          categoriesListMenuMobile.style.display = "none";
        }

        if (
          categoriesListMenuVerticalMobile &&
          categoriesListMenuVertical?.classList.contains("active")
        ) {
          categoriesListMenuVerticalMobile.style.display = "none";
        }

        if (
          categoriesListMenu?.classList.contains("active") ||
          categoriesListMenuVertical?.classList.contains("active")
        ) {
          horizontalList.style.display = "inline-flex";
        }
      }
    },

    initMainMenu: function () {
      const header = document.querySelector("header");
      if (!header) return;

      this.setupNavToggle();
      this.setupMenuMouseEvents();
      this.setupHeaderAttributes();
      this.initStickyHeader(header);
      this.initSubMenu();
    },

    setupNavToggle: function () {
      document.querySelectorAll(".nav-toggle").forEach((navToggle) => {
        navToggle.addEventListener("click", (e) => {
          const target = e.currentTarget;
          const main_menu = document.querySelector(".navigation.horizontal");

          if (document.documentElement.classList.contains("nav-open")) {
            // Close menu
            restoreAllReparentedMenus();
            root.style.removeProperty("padding-right");
            document.documentElement.classList.remove(
              "nav-open",
              "open-drawer"
            );
            target.classList.remove("open");
            if (!main_menu) {
              document.documentElement.classList.remove("nav-verticalmenu");
            }
          } else {
            // Open menu
            root.style.setProperty(
              "padding-right",
              getScrollBarWidth.init() + "px"
            );
            document.documentElement.classList.add("nav-open", "open-drawer");
            target.classList.add("open");
            if (!main_menu) {
              document.documentElement.classList.add("nav-verticalmenu");
            }
          }
        });
      });
    },

    setupMenuMouseEvents: function () {
      let width = screen.width;
      if (width <= 1024) return;

      document
        .querySelectorAll("li.menu-parent .submenu")
        .forEach((menuItem) => {
          menuItem.addEventListener("mouseenter", (e) => {
            const target = e.currentTarget;
            target.closest(".menu-parent").classList.add("active-submenu");
          });

          menuItem.addEventListener("mouseleave", (e) => {
            const target = e.currentTarget;
            target.closest(".menu-parent").classList.remove("active-submenu");
          });
        });
    },

    setupHeaderAttributes: function () {
      let headerpage = document.querySelector("header")?.clientHeight || 0;
      const body = document.querySelector("body");
      body.style.setProperty('--height-header', `${headerpage}px`);
    },

    initStickyHeader: function (header) {
      const sticky = header?.getAttribute("data-sticky");
      const sticky_mobile = header?.getAttribute("data-sticky-mobile");

      if (sticky === "none") return;
      if (sticky_mobile === "false" && window.innerWidth < 1025) return;

      // Setup header sticky behavior
      const headerSpaceH =
        document.getElementById("header-sticky")?.offsetHeight || 0;
      const announcement_bar =
        document.querySelector(".section-announcement-bar")?.clientHeight || 0;
      const top_bar =
        document.querySelector(".section-top-bar")?.clientHeight || 0;
      const headerh = announcement_bar + top_bar + headerSpaceH;
      this.lastScrollPosition = 0; // Initialize lastScrollPosition property
      const sec_header = header.closest(".section-header");

      if (!sec_header) return;

      if (sticky === "on-scroll-up") {
        sec_header.classList.add("scroll-up");
      }

      let _stickyTicking = false;
      window.addEventListener("scroll", () => {
        if (_stickyTicking) return;
        _stickyTicking = true;
        requestAnimationFrame(() => {
          if (!header.classList.contains("open-submenu")) {
            this.updateStickyHeader(sec_header, sticky, headerh);
          }
          _stickyTicking = false;
        });
      }, { passive: true });
    },

    updateStickyHeader: function (sec_header, sticky, headerh) {
      let wpy = window.scrollY;

      if (sticky === "always") {
        // Always sticky behavior
        if (wpy > headerh) {
          sec_header.classList.add("shopify-section-header-sticky", "animate");
        } else {
          sec_header.classList.remove(
            "shopify-section-header-sticky",
            "animate"
          );
        }
      } else {
        // Scroll-up sticky behavior
        if (wpy > 0) {
          if (wpy > headerh) {
            sec_header.classList.add("scr-pass-header");

            if (wpy > this.lastScrollPosition) {
              sec_header.classList.add("shopify-section-header-hidden");
            } else {
              sec_header.classList.remove("shopify-section-header-hidden");
              sec_header.classList.add("animate");
            }
            sec_header.classList.add(
              "header-sticky",
              "shopify-section-header-sticky"
            );
            this.lastScrollPosition = wpy;
          } else {
            sec_header.classList.remove("header-sticky", "scr-pass-header");
            this.lastScrollPosition = 0;
          }
        } else {
          sec_header.classList.remove(
            "shopify-section-header-hidden",
            "header-sticky",
            "animate",
            "shopify-section-header-sticky"
          );
        }
      }
    },

    initSubMenu: function () {
      const main_menu = document.querySelector(".navigation.horizontal");
      if (!main_menu || window.innerWidth <= 1024) return;

      this.addCssSubMenu();

      window.addEventListener("resize", () => {
        if (window.innerWidth > 1024) {
          this.addCssSubMenu();
        }
      });
    },

    addCssSubMenu: function () {
      const bodyWidth =
        document.documentElement.clientWidth || document.body.clientWidth;
      const header = document.querySelector("header");
      const submenu_center = document.querySelector(".submenu-center");
      const width_sub_center = 800;

      if (!header || bodyWidth < 1024) return;

      const padding = 30;
      document
        .querySelectorAll(".horizontal-list .mega-menu-fix-width")
        .forEach((submenu) => {
          if (submenu_center) {
            // Handle center aligned submenu
            const submenu_data = submenu.getBoundingClientRect();
            const width = submenu_data.width;
            const left = submenu_data.left;
            const right = submenu_data.right;

            if (width_sub_center <= width) {
              const left_style = (left - (right - bodyWidth)) / 2;
              submenu.style.left = left_style + "px";
            }
          } else {
            // Handle default submenu positioning
            const elementWidth = submenu.clientWidth;
            const elementLeft = submenu.offsetLeft;

            if (bodyWidth - (elementWidth + elementLeft) < 0) {
              let left = bodyWidth - (elementWidth + elementLeft);
              left = left + elementLeft - padding;

              if (elementLeft < 0) {
                left = 0;
              }

              submenu.style.left = left + "px";
            }
          }
        });
    },

    initVerticalMenu: function () {
      const article = document.querySelector(".verticalmenu-html");
      if (!article) return;

      const verticalMenu = document.querySelector(".vertical-menu");
      if (!verticalMenu) return;
      verticalMenu.addEventListener("mouseenter", function () {
        setTimeout(function () {
          verticalMenu.classList.add("open-vertical");
        }, 150);
      });
      verticalMenu.addEventListener("mouseleave", function () {
        verticalMenu.classList.remove("open-vertical");
      });
      this.setupSimpleHoverIntent(1, ".menu-parent__vertical");
    },

    initMobileMenu: function () {
      // Reserved for mobile menu specific initialization
    },
  };
})();
BlsMainMenuShopify.init();
var BlsSearchShopify = (function () {
  return {
    init: function () {
      var predictive = document.querySelector("#predictive-search");
      if (predictive) {
        this.setupEventListeners();
      }
      const form = document.querySelector("#search-form");
      document.querySelectorAll(".top-search-toggle").forEach((navToggle) => {
        navToggle.onclick = (e) => {
          const target = e.currentTarget;
          if (!form.classList.contains("open")) {
            form.classList.add("open");
            target.classList.add("open");
            document.documentElement.classList.add(
              "open-drawer",
              "open-search"
            );
            root.style.setProperty(
              "padding-right",
              getScrollBarWidth.init() + "px"
            );
            setTimeout(function () {
              form.querySelector('input[type="search"]').focus();
            }, 100);
          } else {
            form.classList.remove("open");
            target.classList.remove("open");
            setTimeout(() => {
              document.documentElement.classList.remove("open-drawer");
              root.style.removeProperty("padding-right");
            }, 300);

            document.documentElement.classList.remove("open-search");
          }
        };
      });
      document.querySelectorAll(".btn-search-close").forEach((navToggle) => {
        navToggle.onclick = () => {
          form.classList.remove("open");
          document
            .querySelector(".dropdown-toggle .top-search-toggle")
            ?.classList.remove("open");
          document.documentElement.classList.remove("open-search");
          setTimeout(() => {
            document.documentElement.classList.remove("open-drawer");
            root.style.removeProperty("padding-right");
          }, 300);
        };
        const overlay_search = document.querySelector(".overlay_search");
        if (overlay_search) {
          overlay_search.onclick = () => {
            navToggle.click();
          };
        }
      });
      const sf = document.querySelector(".search-full");
      if (sf) {
        const hs = sf.closest(".header_search");
        var unSubcribeCloseCanvas;
        if (unSubcribeCloseCanvas) {
          unSubcribeCloseCanvas();
          unSubcribeCloseCanvas = null;
        }
        unSubcribeCloseCanvas = subscribe("closeCanvas", (data) => {
          if (document.documentElement.classList.contains("open-search")) {
            const width = window.innerWidth;
            const ps = document.querySelector(".popup-search");
            if (width >= 767.95 && ps) {
              this.closeDefaultSearch();
            }
          }
        });
        this._boundHandleClickSearch =
          this._boundHandleClickSearch || this.handleClickSearch.bind(this);

        document.removeEventListener("click", this._boundHandleClickSearch);

        document.addEventListener("click", this._boundHandleClickSearch);
      }
    },
    handleClickSearch: function (e) {
      const sf = document.querySelector(".search-full");
      const hs = sf.closest(".header_search");
      const ehs = e.target.closest(".header_search");

      const search_container = e.target.closest("header-search");

      if (ehs || search_container) {
        const ps = document.querySelector(".popup-search");
        const width = window.innerWidth;
        if (ps) {
          ps.classList.add("popup-search-show");
          if (document.documentElement.classList.contains("open-search")) {
            return;
          }
          if (width >= 767.95) {
            this.openDefaultSearch();
          }
        }
      } else {
        if (hs) {
          if (document.documentElement.classList.contains("open-search")) {
            const width = window.innerWidth;
            if (width >= 767.95) {
              this.closeDefaultSearch();
            } else {
              const form = document.querySelector("#search-form");
              form.classList.remove("open");
              if (
                document.documentElement.classList.contains("open-minicart")
              ) {
                document.documentElement.classList.remove("open-search");
              } else {
                document.documentElement.classList.remove(
                  "open-drawer",
                  "open-search"
                );
                root.style.removeProperty("padding-right");
              }
            }
          }
        }
      }
    },
    openDefaultSearch: function () {
      const overlay_search = document.querySelector(".overlay_search");
      const ps = document.querySelector(".popup-search");
      if (!overlay_search || !ps) return;
      const headerNavigation = document.querySelector(
        ".header-bottom__navigation"
      );
      const headerTopActions = document.querySelector(".header-top__actions");
      const headerWrapper = document.querySelector("header");
      if (headerNavigation && headerWrapper) {
        const headerNavigationHeight = headerNavigation.offsetHeight;
        headerNavigation.style.opacity = "0";
        headerNavigation.style.transition = "opacity 0.3s ease";
        headerNavigation.style.display = "none";
        headerWrapper.style.marginBottom = `${headerNavigationHeight}px`;
      }
      overlay_search.classList.add("open");
      const containsHeaderLayoutOne =
        document.querySelector(".header__layout-1");
      const containsHeaderLayoutTwo =
        document.querySelector(".header__layout-2");
      const containsHeaderLayoutThree =
        document.querySelector(".header__layout-3");
      const sf = document.querySelector(
        containsHeaderLayoutOne
          ? "header"
          : containsHeaderLayoutTwo
            ? "header-inner"
            : containsHeaderLayoutThree
              ? ".header-mega-store"
              : ".search-full"
      );
      if (!sf) return;
      let topCaculate = sf.getBoundingClientRect().bottom;
      document.documentElement.classList.add("open-drawer");
      root.style.setProperty("padding-right", getScrollBarWidth.init() + "px");
      Promise.all([
        safeMotionAnimate(
          ps,
          {
            y: ["-105%", topCaculate],
            visibility: ["hidden", "visible"],
          },
          {
            ease: [0.7, 0, 0.2, 1],
            duration: 0.4,
          }
        ),
        safeMotionAnimate(
          overlay_search,
          {
            opacity: [0, 1],
            visibility: ["hidden", "visible"],
          },
          {
            ease: [0.7, 0, 0.2, 1],
            duration: 0.4,
          }
        ),
      ]).then(() => {
        setTimeout(() => {
          document.documentElement.classList.add("open-search");
        }, 20);
      });
    },

    closeDefaultSearch: function () {
      const headerNavigation = document.querySelector(
        ".header-bottom__navigation"
      );
      const headerWrapper = document.querySelector("header");
      const ps = document.querySelector(".popup-search");
      const overlay_search = document.querySelector(".overlay_search");
      if (!overlay_search || !ps) return;
      overlay_search.classList.remove("open");
      ps.classList.remove("popup-search-show");
      if (headerNavigation && headerWrapper) {
        headerNavigation.style.opacity = "";
        headerNavigation.style.transition = "";
        headerNavigation.style.display = "";
        headerWrapper.style.marginBottom = "";
      }
      const containsHeaderLayoutOne =
        document.querySelector(".header__layout-1");
      const containsHeaderLayoutTwo =
        document.querySelector(".header__layout-2");
      const containsHeaderLayoutThree =
        document.querySelector(".header__layout-3");
      const sf = document.querySelector(
        containsHeaderLayoutOne
          ? "header"
          : containsHeaderLayoutTwo
            ? "header-inner"
            : containsHeaderLayoutThree
              ? ".header-mega-store"
              : ".search-full"
      );
      if (!sf) {
        document.documentElement.classList.remove("open-drawer", "open-search");
        root.style.removeProperty("padding-right");
        return;
      }
      let topCaculate = sf.getBoundingClientRect().bottom + 10;
      Promise.all([
        safeMotionAnimate(
          ps,
          {
            y: [topCaculate, "-105%"],
            visibility: ["visible", "hidden"],
          },
          {
            ease: [0.7, 0, 0.2, 1],
            duration: 0.4,
          }
        ),
        safeMotionAnimate(
          overlay_search,
          {
            opacity: [1, 0],
            visibility: ["visible", "hidden"],
          },
          {
            ease: [0.7, 0, 0.2, 1],
            duration: 0.4,
          }
        ),
      ]).then(() => {
        setTimeout(() => {
          if (document.documentElement.classList.contains("open-minicart")) {
            document.documentElement.classList.remove("open-search");
          } else {
            document.documentElement.classList.remove(
              "open-drawer",
              "open-search"
            );
            root.style.removeProperty("padding-right");
          }
        }, 20);
      });
    },

    setupEventListeners: function () {
      const input = document.querySelector('input[type="search"]');
      const form = document.querySelector("form.search");
      if (!input || !form) return;
      form.addEventListener("submit", this.onFormSubmit.bind(this));
      input.addEventListener(
        "input",
        this.debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
      input.addEventListener("focus", this.onFocus.bind(this));
      document.addEventListener("focusout", this.onFocusOut.bind(this));
      document.addEventListener("keyup", this.onKeyup.bind(this));
    },

    debounce: function (fn, wait) {
      let t;
      return function (...args) {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    },

    getQuery: function () {
      return document.querySelector('input[type="search"]').value.trim();
    },

    onChange: function () {
      const searchTerm = this.getQuery();
      const currentLocale = Shopify.locale;
      if (currentLocale !== 'ar') {
        if (!searchTerm.length) {
          this.close(true);
          return;
        }
      }
      this.getSearchResults(searchTerm);
    },

    onFormSubmit: function (event) {
      if (!this.getQuery().length) {
        event.preventDefault();
      }
    },

    onFocus: function () {
      const searchTerm = this.getQuery();
      if (!searchTerm.length) return;
      if (
        document
          .querySelector("#predictive-search")
          .classList.contains("results")
      ) {
        this.open();
      } else {
        this.getSearchResults(searchTerm);
      }
    },

    onFocusOut: function () {
      setTimeout(() => {
        if (!document.contains(document.activeElement)) this.close();
      });
    },

    onKeyup: function (event) {
      if (!event.target.matches('input[type="search"]')) return;
      if (!this.getQuery().length) {
        this.close(true);
        return;
      }

      switch (event.code) {
        case "ArrowUp":
        case "ArrowDown":
          event.preventDefault();
          this.switchOption(event.code === "ArrowUp" ? "up" : "down");
          break;
        case "Enter":
          // Full search results page (agents); native GET submit, not predictive pick only
          return;
      }
    },

    switchOption: function (direction) {
      const predictiveRoot = document.querySelector("#predictive-search");
      if (!predictiveRoot) return;
      const moveUp = direction === "up";
      const selectedElement = predictiveRoot.querySelector('[aria-selected="true"]');
      const allElements = predictiveRoot.querySelectorAll("li[role='option'], li");
      let activeElement = predictiveRoot.querySelector("li");

      if (moveUp && !selectedElement) return;

      this.statusElement.textContent = "";

      if (!moveUp && selectedElement) {
        activeElement = selectedElement.nextElementSibling || allElements[0];
      } else if (moveUp) {
        activeElement =
          selectedElement.previousElementSibling ||
          allElements[allElements.length - 1];
      }

      if (activeElement === selectedElement) return;

      activeElement.setAttribute("aria-selected", true);
      if (selectedElement) selectedElement.setAttribute("aria-selected", false);
      document
        .querySelector('input[type="search"]')
        .setAttribute("aria-activedescendant", activeElement.id);
    },

    selectOption: function () {
      const selectedProduct = document.querySelector(
        '[aria-selected="true"] a, [aria-selected="true"] button'
      );

      if (selectedProduct) selectedProduct.click();
    },

    getSearchResults: function (searchTerm) {
      const cachedResults = {};
      const queryKey = searchTerm.replace(" ", "-").toLowerCase();
      const currentLocale = Shopify.locale;
      if (currentLocale !== 'ar') {
        this.setLiveRegionLoadingState();
      }
      if (cachedResults[queryKey]) {
        this.renderSearchResults(cachedResults[queryKey]);
        return;
      }

      var loading = document.querySelector(".search__loading-state");
      var section_id = "search-predictive-grid";
      var search_url;

      if (document.querySelector(".predictive_search_suggest")) {
        search_url = `${routes?.predictive_search_url
          }?q=${encodeURIComponent(
            searchTerm
          )}&resources[options][fields]=title,tag,vendor,product_type,variants.title,variants.sku&resources[options][prefix]=last&resources[options][unavailable_products]=last&resources[type]=query,product,collection,page,article&section_id=${section_id}`;
      } else {
        search_url = `${routes.search_url}?q=${encodeURIComponent(
          searchTerm
        )}&options[prefix]=last&options[unavailable_products]=last&type=query,product,collection,page,article&section_id=${section_id}`;
      }

      fetch(`${search_url}`)
        .then((response) => {
          let isSuccess = response.status === 200;
          this.handleResponseFlag(isSuccess, searchTerm);

          if (!response.ok) {
            var error = new Error(response.status);
            this.close();
            throw error;
          }

          if (!isSuccess) {
            this.setLiveRegionResults();
            return;
          }


          return response.text();
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, "text/html")
            .querySelector("#shopify-section-" + section_id).innerHTML;

          cachedResults[queryKey] = resultsMarkup;
          this.renderSearchResults(resultsMarkup);
          BlsLazyloadImg.init();
        })
        .catch((error) => {
          this.close();
          throw error;
        });
    },

    handleResponseFlag: function (isSuccess, searchTerm) {
      var collection_suggest = document.querySelector(".collection-suggest");
      if (isSuccess) {
        if (collection_suggest) {
          collection_suggest.style.display = "none";
        }
      } else {
        if (collection_suggest) {
          collection_suggest.style.display = searchTerm.length > 0 ? "none" : "block";
        }
      }
    },

    setLiveRegionLoadingState: function () {
      document.querySelector("#search_mini_form").classList.add("loading");
      document.querySelector("#predictive-search").classList.add("loading");
    },

    setLiveRegionResults: function () {
      document.querySelector("#search_mini_form").classList.remove("loading");
      document.querySelector("#predictive-search").classList.remove("loading");
    },

    renderSearchResults: function (resultsMarkup) {
      document.querySelector("[data-predictive-search]").innerHTML =
        resultsMarkup;
      document.querySelector("#predictive-search").classList.add("results");
      if (document.querySelector(".search-not-sugges")) {
        document
          .querySelector(".search-not-sugges")
          .classList.remove("search-hidden");
        document.documentElement.classList.add("open-drawer", "open-search");
        root.style.setProperty(
          "padding-right",
          getScrollBarWidth.init() + "px"
        );
      }
      const quick_search = document.querySelector("#quick-search");
      if (quick_search) {
        quick_search.classList.add("hidden");
      }
      this.setLiveRegionResults();
      this.open();
    },

    open: function () {
      document
        .querySelector('input[type="search"]')
        .setAttribute("aria-expanded", true);
      this.isOpen = true;
    },

    close: function (clearSearchTerm = false) {
      if (clearSearchTerm) {
        document.querySelector('input[type="search"]').value = "";
        document
          .querySelector("#predictive-search")
          .classList.remove("results");
        if (document.querySelector(".search-not-sugges")) {
          document
            .querySelector(".search-not-sugges")
            .classList.add("search-hidden");
          document.documentElement.classList.remove(
            "open-drawer",
            "open-search"
          );
          root.style.removeProperty("padding-right");
        }

        const quick_search = document.querySelector("#quick-search");
        if (quick_search) {
          quick_search.classList.remove("hidden");
        }
      }
      const selected = document.querySelector('[aria-selected="true"]');
      if (selected) selected.setAttribute("aria-selected", false);
      document
        .querySelector('input[type="search"]')
        .setAttribute("aria-activedescendant", "");
      document
        .querySelector('input[type="search"]')
        .setAttribute("aria-expanded", false);
      this.resultsMaxHeight = false;
      document
        .querySelector("[data-predictive-search]")
        .removeAttribute("style");
      this.isOpen = false;
    },
  };
})();
BlsSearchShopify.init();
class HeaderSearch extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    const _this = this;
    const header = document.querySelector("header");
    const button_search_default = document.querySelector(
      "#button_search_default"
    );
    if (
      header.classList.contains("popup-search-mobile") &&
      this.classList.contains("search_type_default")
    ) {
      let sectionId = "top-search";
      if (window.innerWidth <= 767) {
        _this.fetchUrl(
          `${window.location.pathname}?section_id=${sectionId}&type=popup&ajax=1`,
          "popup"
        );
        button_search_default.classList.add("top-search-toggle");
      }
      let width = window.innerWidth;
      window.addEventListener("resize", function () {
        const newWidth = window.innerWidth;

        if (newWidth <= 767 && width > 767) {
          const overlay_search = document.querySelector(".overlay_search");
          overlay_search.style.visibility = "hidden";
          overlay_search.style.opacity = 0;
          overlay_search.classList.remove("open");
          _this.fetchUrl(
            `${window.location.pathname}?section_id=${sectionId}&type=popup&ajax=1`,
            "popup"
          );
          button_search_default.classList.add("top-search-toggle");
        }
        if (newWidth > 767 && width <= 767) {
          button_search_default.classList.remove("top-search-toggle");
          _this.fetchUrl(
            `${window.location.pathname}?section_id=${sectionId}&type=default&ajax=1`
          );
          var popup_search_form_popup = document.querySelector(
            ".search__type-popup"
          );
          if (popup_search_form_popup) {
            popup_search_form_popup.style.display = "none";
          }
        }
        width = newWidth;
      });
    } else {
      let width = window.innerWidth;
      window.addEventListener("resize", function () {
        const newWidth = window.innerWidth;
        var popup_search_form_popup = document.querySelector(
          ".search__type-popup"
        );
        if (newWidth <= 767 && width > 767) {
          if (
            popup_search_form_popup &&
            !document.documentElement.classList.contains("open-search")
          ) {
            popup_search_form_popup.style.display = "none";
            setTimeout(() => {
              popup_search_form_popup.style.display = "block";
            }, 20);
          }
        }
        if (newWidth > 767 && width <= 767) {
          if (
            popup_search_form_popup &&
            !document.documentElement.classList.contains("open-search")
          ) {
            popup_search_form_popup.style.display = "none";
            setTimeout(() => {
              popup_search_form_popup.style.display = "block";
            }, 20);
          }
        }

        width = newWidth;
      });
    }
  }
  fetchUrl(url, type = "default") {
    var input = document.querySelector(".search__input");
    if (type == "default") {
      input.setAttribute("type", "search");
    } else {
      input.removeAttribute("type");
    }
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const newSection = new DOMParser()
          .parseFromString(responseText, "text/html")
          .querySelector("header-search").innerHTML;
        document.querySelector("header-search").innerHTML = newSection;
      })
      .catch((e) => {
        throw e;
      })
      .finally(() => {
        if (document.documentElement.classList.contains("open-search")) {
          document.documentElement.classList.remove(
            "open-search",
            "open-drawer"
          );
        }
        BlsSearchShopify.init();
      });
  }
}

customElements.define("header-search", HeaderSearch);;
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });
    this.input.addEventListener("change", this.onInputChange.bind(this));
    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.quantityUpdate,
      this.validateQtyRules.bind(this)
    );
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange() {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ||
      event.target.closest("button").name === "plus"
      ? this.input.stepUp()
      : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle("disabled", value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle("disabled", value >= max);
    }
  }
}

customElements.define("quantity-input", QuantityInput);

class ProgressBar extends HTMLElement {
  constructor() {
    super();
    const orders = this.dataset.order;
    this.init(orders);
  }
  init(orders) {
    const fe_unavaiable = this.dataset.feUnavaiable;
    const fe_avaiable = this.dataset.feAvaiable;
    const rate = Number(Shopify.currency.rate);
    const min = Number(this.dataset.feAmount);
    if (!min || !rate) return;
    const order = Number(orders) / 100;
    const min_by_currency = min * rate;
    if (order == undefined) return;
    if ((order / min_by_currency) * 100 > 100) {
      this.setProgressBar(100);
    } else {
      this.setProgressBar((order / min_by_currency) * 100);
    }
    this.setProgressBarTitle(
      order,
      min_by_currency,
      fe_unavaiable,
      fe_avaiable
    );
  }
  setProgressBarTitle(order, min_by_currency, fe_unavaiable, fe_avaiable) {
    const title = this.querySelector(".free-shipping-message");
    if (!title) return;
    title.classList.remove("opacity-0");
    if (order >= min_by_currency) {
      title.innerHTML = fe_avaiable;
    } else {
      const ammount = "{{ amount }}";
      title.innerHTML = fe_unavaiable.replace(
        ammount.trim(),
        Shopify.formatMoney(
          (min_by_currency - order) * 100,
          cartStrings.money_format
        )
      );
    }
  }
  setProgressBar(progress) {
    const p = this.querySelector(".progress");
    p.style.width = progress + "%";
    if (progress === 100) {
      this.classList.add("cart_shipping_free");
    } else {
      this.classList.remove("cart_shipping_free");
    }
  }
}
customElements.define("free-ship-progress-bar", ProgressBar);

// Restore a reparented .sub-children-menu to its original DOM position
function restoreReparentedMenu(el) {
  if (!el || !el._originalParent) return;
  if (el._rafId) { cancelAnimationFrame(el._rafId); el._rafId = null; }
  el.classList.remove("is-active");
  el._originalParent.insertBefore(el, el._originalNext || null);
  el._originalParent = null;
  el._originalNext = null;
}

// Restore all reparented sub-children-menus and clean up state
function restoreAllReparentedMenus() {
  document.querySelectorAll(".sub-children-menu.is-active").forEach((el) => {
    el.classList.remove("is-active");
  });
  document.querySelectorAll(".sub-children-menu").forEach((el) => {
    restoreReparentedMenu(el);
  });
  document.querySelectorAll("menu-item").forEach((item) => {
    item.classList.remove("is-open");
    item._reparentedMenu = null;
  });
}

class OpenChildrenToggle extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onToggle.bind(this), false);
  }
  onToggle() {
    const menuItem = this.parentElement;
    if (!menuItem) return;

    if (!menuItem.classList.contains("is-open")) {
      menuItem.classList.add("is-open");
      // Mobile: reparent sub-children-menu to .submenu for full-screen overlay
      if (window.innerWidth < 1025) {
        // If a pending restore exists, complete it synchronously first
        const pending = menuItem._reparentedMenu;
        if (pending && pending._originalParent) {
          restoreReparentedMenu(pending);
        }
        const subMenu = menuItem.nextElementSibling;
        if (subMenu && subMenu.classList.contains("sub-children-menu")) {
          // Reparent to <nav> — it's position:fixed;inset:0 with no
          // transform/overflow, so absolute children cover the full viewport.
          const navEl = subMenu.closest("nav.navigation");
          if (navEl) {
            subMenu._originalParent = subMenu.parentElement;
            subMenu._originalNext = subMenu.nextElementSibling;
            subMenu.scrollTop = 0;
            menuItem._reparentedMenu = subMenu;
            navEl.appendChild(subMenu);
            subMenu._rafId = requestAnimationFrame(() => {
              subMenu._rafId = null;
              if (subMenu._originalParent) subMenu.classList.add("is-active");
            });
          }
        }
      }
    } else {
      menuItem.classList.remove("is-open");
      // Mobile: restore sub-children-menu after close
      if (window.innerWidth < 1025) {
        const subMenu = menuItem._reparentedMenu;
        if (subMenu && subMenu._originalParent) {
          menuItem._reparentedMenu = null;
          subMenu.classList.remove("is-active");
          restoreReparentedMenu(subMenu);
        }
      }
    }
  }
}
customElements.define("open-children-toggle", OpenChildrenToggle);

class DesktopSubmenuToggle extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onToggle.bind(this), false);
  }
  onToggle(e) {
    e.preventDefault();
    e.stopPropagation();
    const levelItem = this.closest(".level-1");
    if (levelItem) {
      const isExpanding = !levelItem.classList.contains("is-expanded");
      if (isExpanding) {
        levelItem.parentElement.querySelectorAll(".level-1.is-expanded").forEach(sibling => {
          if (sibling !== levelItem) sibling.classList.remove("is-expanded");
        });
      }
      levelItem.classList.toggle("is-expanded");
    }
  }
}
customElements.define("desktop-submenu-toggle", DesktopSubmenuToggle);

class CloseMenu extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onClose.bind(this), false);
  }
  onClose() {
    document.querySelector(".nav-toggle").classList.remove("open");
    restoreAllReparentedMenus();
    document.documentElement.classList.remove("nav-open");
    setTimeout(() => {
      document.documentElement.classList.remove("open-drawer");
      root.style.removeProperty("padding-right");
    }, 400);
  }
}
customElements.define("close-menu", CloseMenu);

class BackMenu extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", this.onBackMenu.bind(this), false);
  }
  onBackMenu() {
    if (this.classList.contains("back-lv1")) {
      const subChildrenMenu = this.closest(".sub-children-menu");
      if (subChildrenMenu && subChildrenMenu._originalParent) {
        const levelItem = subChildrenMenu._originalParent.closest(".level-1");
        if (levelItem) {
          const mi = levelItem.querySelector("menu-item");
          if (mi) { mi.classList.remove("is-open"); mi._reparentedMenu = null; }
        }
        subChildrenMenu.classList.remove("is-active");
        restoreReparentedMenu(subChildrenMenu);
      } else {
        // Fallback for non-reparented case (desktop)
        const levelItem = this.closest(".level-1");
        if (levelItem) {
          levelItem.querySelector("menu-item")?.classList.remove("is-open");
        }
      }
    } else {
      this.closest(".level0")
        ?.querySelector("menu-item")
        ?.classList.remove("is-open");
    }
  }
}
customElements.define("back-menu", BackMenu);

var BlsLoginPopup = (function () {
  return {
    init: function () {
      this.showLogin();
    },
    clickTab: function (modal) {
      const hidden = document.querySelectorAll("[data-login-hidden]");
      const show = document.querySelectorAll("[data-login-show]");
      const iTitle = document.querySelector("#login-popup .login-heading");
      show.forEach((e) => {
        var s = e?.dataset.loginShow;
        e.addEventListener("click", function (el) {
          el.preventDefault();
          hidden.forEach((eh) => {
            var h = eh?.dataset.loginHidden;
            if (eh.getAttribute("aria-hidden") === "true" && s === h) {
              eh.setAttribute("aria-hidden", "false");
              if (iTitle) {
                iTitle.innerText = s;
              }
            } else {
              eh.setAttribute("aria-hidden", "true");
            }
          });
        });
      });
    },
    showLogin: function () {
      const action = document.querySelector(".action-login-popup");
      const _this = this;
      if (action) {
        action.addEventListener("click", (e) => {
          e.preventDefault();
          _this.fetchDataLogin(e);
        });
      }
    },
    fetchDataLogin: function (event) {
      const _this = this;
      const currentTarget = event.currentTarget;
      const template = currentTarget.querySelector("template");
      if (template) {
        const content = template.content.firstElementChild.cloneNode(true).outerHTML;
        if (content) {
          const modal = new tingle.modal({
            footer: false,
            stickyFooter: false,
            closeMethods: ["overlay", "button", "escape"],
            closeLabel: "Close",
            cssClass: ["login-popup-modal"],
            onOpen: function () { },
            onClose: function () { },
            beforeOpen: function () { },
            beforeClose: function () {
              return true;
            },
          });
          modal.setContent(content);
          modal.open();
          document
            .querySelectorAll(".login__popup-button-close")
            .forEach((navToggle) => {
              navToggle.addEventListener(
                "click",
                (e) => {
                  e.preventDefault();
                  modal.close();
                },
                false
              );
            });
        }
        _this.clickTab();
      }
    },
  };
})();
BlsLoginPopup.init();

class LocalizationForm extends HTMLElement {
  constructor() {
    super();
    this.elements = {
      input: this.querySelector(
        'input[name="language_code"], input[name="country_code"]'
      ),
      button: this.querySelector(".button-localization"),
      panel: this.querySelector("ul"),
    };
    this.elements.button.addEventListener(
      "click",
      this.openSelector.bind(this)
    );
    this.elements.button.addEventListener(
      "focusout",
      this.closeSelector.bind(this)
    );
    this.addEventListener("keyup", this.onContainerKeyUp.bind(this));
    this.querySelectorAll("a").forEach((item) =>
      item.addEventListener("click", this.onItemClick.bind(this))
    );
    this.onBodyClick = this.handleBodyClick.bind(this);
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target != this && !target.closest("localization-form")) {
      this.hidePanel();
    }
  }

  hidePanel() {
    document.body.removeEventListener("click", this.onBodyClick);
    this.elements.button.classList.remove("open");
  }

  onContainerKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;
    this.hidePanel();
    this.elements.button.focus();
  }

  onItemClick(event) {
    event.preventDefault();
    const form = this.querySelector("form");
    this.elements.input.value = event.currentTarget.dataset.value;
    if (form) form.submit();
  }

  openSelector() {
    if (this.elements.button.classList.contains("open")) {
      this.hidePanel();
    } else {
      document.body.addEventListener("click", this.onBodyClick);
      this.elements.button.focus();
      for (var item of document.querySelectorAll(".button-localization")) {
        item.classList.remove("open");
      }
      this.elements.button.classList.add("open");
    }
  }

  closeSelector(event) {
    const shouldClose =
      event.relatedTarget && event.relatedTarget.nodeName === "BUTTON";
    if (event.relatedTarget === null || shouldClose) {
      this.hidePanel();
    }
  }
}
customElements.define("localization-form", LocalizationForm);

class CollapsibleBlock extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    const block = _this.querySelectorAll(".collapsible-heading");
    block.forEach((event) => {
      event.addEventListener("click", (e) => {
        const target = e.currentTarget;
        const parent = target.parentElement;
        const footerContent = parent.querySelector(".collapsible-content");
        if (
          _this.closest(".collection-filter") &&
          _this
            .closest(".collection-filter")
            .classList.contains("horizontal") &&
          window.innerWidth > 1024
        ) {
          if (!_this.classList.contains("active")) {
            const filterContainer = _this.closest(".collection-filter") || document;
            const prevActive = filterContainer.querySelector("collapsible-block.active");
            if (prevActive && prevActive !== _this) {
              prevActive.classList.remove("active");
              prevActive.setAttribute("aria-expanded", "false");
            }
            _this.classList.add("active");
            _this.setAttribute("aria-expanded", "true");
          } else {
            _this.classList.remove("active");
            _this.setAttribute("aria-expanded", "false");
          }
        } else {
          slideAnime({
            target: footerContent,
            animeType: "slideToggle",
          });
          if (!_this.classList.contains("active")) {
            _this.classList.add("active");
            _this.setAttribute("aria-expanded", "true");
          } else {
            _this.classList.remove("active");
            _this.setAttribute("aria-expanded", "false");
          }
        }
      });
    });
    document.body.addEventListener("click", this.handleBodyClick.bind(this));
    if (this.classList.contains("collection")) {
      this.actionInMobile();
      window.addEventListener("resize", () => {
        this.actionInMobile();
      });
    }
  }

  actionInMobile() {
    var _this = this;
    var width = window.innerWidth;
    if (width <= 1024) {
      const footerContent = _this.querySelector(".collapsible-content");
      if (footerContent) footerContent.style.display = "block";
      _this.classList.add("active");
      _this.setAttribute("aria-expanded", "true");
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (
      target != this &&
      !target.closest("collapsible-block") &&
      document.querySelector(".collection-filter") &&
      document
        .querySelector(".collection-filter")
        .classList.contains("horizontal") &&
      window.innerWidth > 1024
    ) {
      const block = document
        .querySelector(".collection-filter")
        .querySelectorAll("collapsible-block");
      block.forEach((collapsible) => {
        collapsible.classList.remove("active");
        collapsible.setAttribute("aria-expanded", "false");
      });
    }
  }
}
customElements.define("collapsible-block", CollapsibleBlock);

class StickyElement extends HTMLElement {
  constructor() {
    super();
    this.collapsibleHeading = this.querySelector(".collapsible-bundle");
    this.contentWrapper = this.querySelector(".bundle-items__wrapper");
    this.isOpen = true;
    this.isMobile = window.innerWidth <= 1024;
    this.init();
  }

  init() {
    if (this.isMobile) {
      this.setupCollapsible();
    }

    window.addEventListener("resize", this.onResize.bind(this));
  }

  setupCollapsible() {
    if (!this.collapsibleHeading || !this.contentWrapper) return;

    if (this.isMobile) {
      this.isOpen = false;
      this.contentWrapper.style.display = "none";
      this.classList.remove("opened");
    }

    if (!this.collapsibleHeading.hasEventListener) {
      this.collapsibleHeading.hasEventListener = true;
      this.collapsibleHeading.addEventListener(
        "click",
        this.toggleCollapse.bind(this)
      );
    }
  }

  toggleCollapse(event) {
    if (!this.isMobile) return;

    event.preventDefault();

    this.isOpen = !this.isOpen;

    slideAnime({
      target: this.contentWrapper,
      animeType: "slideToggle",
      parent: this,
    });
  }

  onResize() {
    const wasMobile = this.isMobile;
    this.isMobile = window.innerWidth <= 1024;

    if (wasMobile !== this.isMobile) {
      if (this.isMobile) {
        this.setupCollapsible();
      } else {
        if (this.contentWrapper) {
          this.contentWrapper.style.display = "block";
          this.contentWrapper.style.height = "auto";
        }
      }
    }
  }

  showContent() {
    if (this.isMobile && !this.isOpen && this.contentWrapper) {
      this.isOpen = true;
      slideAnime({
        target: this.contentWrapper,
        animeType: "slideDown",
        parent: this,
      });
      this.classList.add("opened");
    }
  }
}

customElements.define("sticky-element", StickyElement);

class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    const _this = this;
    const close = _this.querySelector(".announcement-bar-close");
    if (!close) {
      return;
    }
    close.addEventListener("click", (e) => {
      slideAnime({
        target: _this,
        animeType: "slideToggle",
      });
      sessionStorage.setItem("announcement_bar", "false");
    });
  }
}
customElements.define("announcement-bar", AnnouncementBar);

class AgeVerifier extends HTMLElement {
  constructor() {
    super();
    this.ageVerifyDetail = this.querySelector(".age-verify-detail");
    this.declineVerifyDetail = this.querySelector(".decline-verify-detail");
    this.init();
    this.mainFunction();
  }
  init() {
    const _this = this;
    if (!Shopify.designMode) {
      if (!getCookie("age_verifier")) {
        this.classList.add("active");
        this.declineVerifyDetail.classList.add("hidden");
        this.ageVerifyDetail.classList.remove("hidden");
      } else {
        if (getCookie("age_verifier") == "false") {
          this.classList.add("active");
          this.declineVerifyDetail.classList.remove("hidden");
          this.ageVerifyDetail.classList.add("hidden");
        } else {
          this.remove();
        }
      }
    }
  }

  mainFunction() {
    const approve = this.querySelector(".age-verifier-approve");
    const decline = this.querySelector(".age-verifier-decline");
    const returnBtn = this.querySelector(".age-verifier-return");
    if (returnBtn) {
      returnBtn.addEventListener("click", () => this.handleReturn());
    }

    if (!approve || !decline) return;
    approve.addEventListener("click", () => this.handleApprove());
    decline.addEventListener("click", () => this.handleDecline());
  }
  handleReturn() {
    if (!Shopify.designMode) {
      setCookie("age_verifier", "false", "-1");
      this.init();
    }
  }
  handleDecline() {
    if (!Shopify.designMode) {
      setCookie("age_verifier", "false", "365");
      this.init();
    }
  }
  handleApprove() {
    setCookie("age_verifier", "true", "false");
    this.classList.add("fadeOut");
    setTimeout(() => {
      this.remove();
    }, 1000);
  }
}
if (!customElements.get('age-verifier')) customElements.define("age-verifier", AgeVerifier);


class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    setTimeout(() => {
      this.init();
    }, 12000);
  }
  init() {
    const sectionId = this.dataset.sectionId;
    const url = `${window.location.pathname}?section_id=${sectionId}&ajax=1`;
    fetch(`${url}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((responseText) => {
        const newSection = new DOMParser()
          .parseFromString(responseText, "text/html")
          .querySelector("newsletter-popup").innerHTML;
        document.querySelector("newsletter-popup").innerHTML = newSection;
      })
      .catch((error) => {
        throw error;
      })
      .finally(() => {
        this.initPopup();
      });
  }

  initPopup() {
    const _this = this;
    const s = _this?.dataset.show;
    const m = _this?.dataset.showMb === "true";
    
    if (!Shopify.designMode) {
      const cookie = getCookie("newsletter_popup");
      const width = window.innerWidth;
      
      if (!m && width < 768) return false;
      
      if ((s == "show_homepage" || s == "show_all_page") && cookie === "") {
        const modal = new tingle.modal({
          footer: false,
          stickyFooter: false,
          closeMethods: ["overlay", "button", "escape"],
          closeLabel: "Close",
          beforeOpen: function () {
            if (typeof CloseAllPopup === 'function') CloseAllPopup();
          },
          cssClass: [
            `newsletter-popup-modal`,
            `${m ? "show-all" : "disable-on-mobile"}`,
          ],
        });
        modal.setContent(_this.innerHTML);
        modal.open();
        _this.onShowNewletter();
      }
    }
  }

  onShowNewletter() {
    const _this = this;
    const setC = document.querySelector(
      ".newsletter-popup-modal .newsletter-popup__dont-show"
    );
    if (!setC) return;
    setC.addEventListener("click", _this.notShow.bind(_this));
    setC.addEventListener(
      "keypress",
      function (event) {
        if (event.key === "Enter") {
          _this.notShow.bind(_this)(event);
        }
      }.bind(_this),
      false
    );
  }

  notShow(e) {
    e.preventDefault();
    setCookie("newsletter_popup", 30, 1);
    document
      .querySelector(".newsletter-popup-modal .tingle-modal__close")
      .click();
  }
}
if (!customElements.get('newsletter-popup')) customElements.define("newsletter-popup", NewsletterPopup);

var returnMessageWhenSubmit = (function () {
  return {
    init: function () {
      this.checkUrlReturn();
    },
    checkUrlReturn: function () {
      const getUrl = window.location.href;
      if (
        getUrl.indexOf("customer_posted=true#newsletter-form") >= 1 ||
        getUrl.indexOf("customer_posted=true") >= 1
      ) {
        this.handleMessageSuccessPopup();
        setCookie("newsletter_popup", 30, 1);
        const newURL = location.href.split("?")[0];
        window.history.pushState("object", document.title, newURL);
      }

      if (
        getUrl.indexOf("contact%5Btags%5D=newsletter&form_type=customer") >= 1
      ) {
        this.handleMessageErrorPopup();
        const newURL = location.href.split("?")[0];
        window.history.pushState("object", document.title, newURL);
      }
    },

    handleMessageSuccessPopup: function () {
      const url = `${window.location.pathname}?section_id=form-message`;
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const elementSuccessMessage = html.querySelector(
            ".newsletter-form__success-message-wrapper"
          );
          showToast(elementSuccessMessage.innerHTML, 3000, "modal-success");
        })
        .catch((e) => {
          throw e;
        });
    },

    handleMessageErrorPopup: function () {
      const url = `${window.location.pathname}?section_id=form-message`;
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(
            responseText,
            "text/html"
          );
          const elementErrorMessage = html.querySelector(
            ".newsletter-form__error-message-wrapper"
          );
          const elementMessage = elementErrorMessage.querySelector(
            ".newsletter-form__message"
          );
          showToast(elementErrorMessage.innerHTML, 3000, "modal-error");
        })
        .catch((e) => {
          throw e;
        });
    },
  };
})();
returnMessageWhenSubmit.init();
class NavBar extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init() {
    document.body.classList.add("mobi-navigation-bar");
  }
}
customElements.define("mobile-navigation-bar", NavBar);

class CarouselMobile extends SlideSection {
  constructor() {
    super();
    this.enable = this.dataset.enable;
    this.swiperSlideInnerHtml = this.innerHTML;
    this.id = this.dataset.id;
    this.init();
  }
  init() {
    if (this.enable == "true") {
      let width = window.innerWidth;
      window.addEventListener("resize", () => {
        const newWidth = window.innerWidth;
        if (newWidth <= 767 && width > 767) {
          this.actionOnMobile();
        }
        if (newWidth > 767 && width <= 767) {
          this.actionOutMobile();
        }
        width = newWidth;
      });
      if (width <= 767) {
        this.actionOnMobile();
      } else {
        this.actionOutMobile();
      }
    }
  }
  actionOnMobile() {
    this.classList.add("swiper");
    this.classList.remove("grid", "grid-cols");
    const html = this.swiperSlideInnerHtml.replaceAll(
      "sec__icon-switch-slide",
      "swiper-slide"
    );
    const wrapper = `<div class='swiper-wrapper'>${html}</div> <div
    class="swiper-pagination swiper-pagination-${this.id}  ${this.enable && this.dataset.mobile != 1.5 ? "flex" : "hidden"
      } px-15 lh-1 bottom-30 justify-content-center"
    style="--swiper-pagination-bottom: 3rem;--swiper-pagination-position: static;"
  ></div> `;
    this.innerHTML = wrapper;
    this.initSlide();
    this.actionPointer();
    this.closest("motion-items-effect")?.init?.();
  }
  actionOutMobile() {
    this.classList.remove("swiper");
    this.classList.add("grid", "grid-cols");
    this.innerHTML = this.swiperSlideInnerHtml;
    this.closest("motion-items-effect")?.init?.();
  }
  actionPointer() {
    this.addEventListener('pointerup', (e) => {
      const multiContent = this.closest("multi-content");
      if (!multiContent || !multiContent.swiper) return;
      multiContent.swiper.allowTouchMove = true;
    });
    this.addEventListener('pointerdown', (e) => {
      const multiContent = this.closest("multi-content");
      if (!multiContent || !multiContent.swiper) return;
      multiContent.swiper.allowTouchMove = false;
    });
  }
}
customElements.define("carousel-mobile", CarouselMobile);

class PaginationCache {
  static saveState() {
    const list = document.querySelector('.loadmore-lists');
    if (!list) return;
    setTimeout(() => {
      try {
        const loadMore = document.querySelector('.actions-loadmore');
        sessionStorage.setItem('jm_pg_html', list.innerHTML);
        sessionStorage.setItem('jm_pg_next', loadMore ? loadMore.getAttribute('href') : '');
        sessionStorage.setItem('jm_pg_url', window.location.pathname + window.location.search);
      } catch (e) {
        console.warn('Pagination cache save failed: ', e);
      }
    }, 10);
  }

  static saveScroll() {
    if (!document.querySelector('.loadmore-lists')) return;
    try {
      sessionStorage.setItem('jm_pg_scroll', window.scrollY);
    } catch (e) { }
  }

  static restore() {
    try {
      const savedUrl = sessionStorage.getItem('jm_pg_url');
      const currentUrl = window.location.pathname + window.location.search;
      if (!savedUrl || savedUrl !== currentUrl) {
        return false;
      }

      const navEntries = performance.getEntriesByType('navigation');
      if (navEntries.length > 0) {
        const type = navEntries[0].type;
        if (type !== 'back_forward') {
          sessionStorage.removeItem('jm_pg_html');
          return false;
        }
      } else if (performance.navigation && performance.navigation.type !== 2) {
        sessionStorage.removeItem('jm_pg_html');
        return false;
      }

      const html = sessionStorage.getItem('jm_pg_html');
      const list = document.querySelector('.loadmore-lists');

      if (html && list) {
        list.innerHTML = html;
        const next = sessionStorage.getItem('jm_pg_next');
        const loadMoreOuter = document.querySelector('.load-more-bar');
        const loadMore = document.querySelector('.actions-loadmore');

        if (loadMore) {
          if (next) {
            loadMore.setAttribute('href', next);
          } else {
            if (loadMoreOuter) loadMoreOuter.innerHTML = '';
            loadMore.remove();
          }
        }

        if (typeof initLazyloadItem === 'function') initLazyloadItem();
        if (typeof BlsLazyloadImg !== 'undefined') BlsLazyloadImg.init();

        requestAnimationFrame(() => {
          setTimeout(() => {
            const scrollY = sessionStorage.getItem('jm_pg_scroll');
            if (scrollY) window.scrollTo({ top: parseInt(scrollY), behavior: 'instant' });
            if (window.jmProcessCollectionGrid) window.jmProcessCollectionGrid();
          }, 100);
        });
        return true;
      }
    } catch (e) {
      console.warn('Pagination restore failed', e);
    }
    return false;
  }
}

const initPaginationRestore = () => {
  if (window.jmPaginationRestored) return;
  window.jmPaginationRestored = true;
  PaginationCache.restore();
};

window.addEventListener('pagehide', PaginationCache.saveScroll);

window.addEventListener('pageshow', (e) => {
  if (e.persisted) {
    document.querySelectorAll('.loading_image').forEach((el) => {
      el.classList.add('hidden');
    });
  } else {
    initPaginationRestore();
  }
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPaginationRestore);
} else {
  initPaginationRestore();
}

class PaginateLoadmore extends HTMLElement {
  constructor() {
    super();
    this.initLoadMore();
    if (this.classList.contains("collection-list__page")) {
      this.querySelector("a").addEventListener(
        "click",
        async (e) => {
          this.toggleLoading(e.currentTarget, true);
          await new Promise((resolve, reject) => {
            setTimeout(() => {
              resolve();
              this.toggleLoading(e.currentTarget, false);
              this.remove();
            }, 400);
          });
          for (var item of document.querySelectorAll(
            ".sec__collections-list .collection-item.grid-custom-item"
          )) {
            item.classList.remove("hidden");
          }
          const motionCollection = document.querySelector(".motion-collection");
          if (motionCollection && typeof motionCollection.reloadAnimationEffect === 'function') {
            motionCollection.reloadAnimationEffect();
          }
        },
        false
      );
    }
  }
  initLoadMore() {
    this.querySelectorAll(".actions-loadmore").forEach((loadMore) => {
      var _this = this;
      if (loadMore.classList.contains("infinit-scrolling")) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach((entry) => {
              if (entry.intersectionRatio === 1) {
                _this.loadMoreItem(loadMore);
              }
            });
          },
          { threshold: 1.0 }
        );
        observer.observe(loadMore);
      } else {
        loadMore.addEventListener(
          "click",
          (event) => {
            event.preventDefault();
            const target = event.currentTarget;
            _this.loadMoreItem(target);
          },
          false
        );
      }
    });
  }
  loadMoreItem(target) {
    const loadMore_url = target.getAttribute("href");
    const _this = this;
    let sectionContainer = document.querySelector(`#product-grid`);
    sectionContainer?.classList.add("bls-image-js");
    _this.toggleLoading(target, true);
    fetch(`${loadMore_url}`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }
        return response.text();
      })
      .then((responseText) => {
        const resultNodes = parser.parseFromString(responseText, "text/html");
        const resultNodesHtml = resultNodes.querySelectorAll(
          ".loadmore-lists .loadmore-item"
        );
        resultNodesHtml.forEach((prodNode) =>
          document.querySelector(".loadmore-lists").appendChild(prodNode)
        );
        const load_more = resultNodes.querySelector(".actions-loadmore");
        document.querySelector(".load-more-bar").innerHTML =
          resultNodes.querySelector(".load-more-bar").innerHTML;
        if (load_more) {
          target.setAttribute("href", load_more.getAttribute("href"));
        } else {
          target.remove();
        }
        _this.toggleLoading(target, false);
      })
      .catch((error) => {
        throw error;
      })
      .finally(async () => {
        const motionCollection = document.querySelector(".motion-collection");
        if (motionCollection && typeof motionCollection.reloadAnimationEffect === 'function') {
          motionCollection.reloadAnimationEffect();
        }
        initLazyloadItem();
        BlsLazyloadImg.init();
        if (typeof PaginationCache !== 'undefined') {
          PaginationCache.saveState();
        }
      });
  }
  toggleLoading(event, loading) {
    if (event) {
      const method = loading ? "add" : "remove";
      event.classList[method]("loading");
    }
  }
}
customElements.define("loadmore-button", PaginateLoadmore);

class SingleItem extends HTMLElement {
  constructor() {
    super();
    this.position = this.dataset.position;
    this.section = this.closest(".section-slide-single");
    this.init();
  }
  init() {
    this.addEventListener("click", this.onClick.bind(this));
  }
  onClick() {
    if (this.section && this.position) {
      const slideSEction = this.section.querySelector(`slide-section-single`);
      const allDots = this.section.querySelectorAll(`single-item`);
      allDots.forEach((dot) => {
        dot.classList.remove("active");
      });
      this.classList.add("active");
      if (slideSEction) {
        slideSEction.functionGoto(this.position);
      }
    }
  }
}
customElements.define("single-item", SingleItem);

class SlideSectionSingle extends SlideSection {
  constructor() {
    super();
    this.init();
  }
  init() {
    this.initSlide();
  }
  functionGoto(position) {
    this.globalSlide.slideToLoop(position - 1, 500);
  }
}
customElements.define("slide-section-single", SlideSectionSingle);

// --- Extracted components (Phase 1.2–1.4e) ---
// bundle-components.js: VariantRadiosQuickEdit, VariantRadiosBundle, ProductFormBundle, QuantityInputBundle, ButtonSubmitBundle, ProgressBundleBar, ProductFormQuickEdit
// popup-components.js / cart-drawer.js / global-components.js: ShowPassWord, BeforeYouLeave, MiniCartRemoveButton, MiniCartWishlistAction, CookieBar, TermsConditions, HeaderTotalPrice
// quick-view.js: QuickView, ButtonQuickView, ButtonSelectOptions
// wishlist-button.js: ButtonWishlist | compare-button.js: ButtonCompare
// variant-radios.js: SwatchFunctions, SwatchDropdownSelectValue, VariantRadios, VariantRadiosDetail, VariantRadiosSingle, VariantGroupDetail, VariantRadiosSticky, VariantGroupSticky
// countdown-timer.js: CountdownTimer
// product-form.js: ProductForm, SlideWithThumbs, MediaGallery, IdeaProducts, ProgressStockBar, ProductWithBanner, ProductAddons
// section-components.js: Loadmore, TabItems, GridCustom, ProductRecentlyViewed, BlsCustomer, CountUp
// lookbook-components.js: LookbookItem, SectionSlideLookbook, SectionSlideInstagramShop, InstagramShop, PopupLink, LookbookToggleButton
